import SalesStats from './SalesStats';
// import CategoryInsightListItem from './CategoryInsightListItem';

function CategoryInsights({ categoryData }) {
    return (
        <div className="mt-6 mx-5">
            <h1 className='font-bold text-[24px] leading-8 font-urbanist-regular'>{categoryData.name} Insights</h1>

            <SalesStats />

            <div className="products-list">
                <div className="mt-3 border border-[#EAEAEA] rounded-lg">
                    <div className="flex bg-[#F5F5F5] font-urbanist-regular font-semibold">
                        <h2 className="w-[49%] px-[10px] py-2 text-[16px] leading-8 text-[#121212]">Collection name</h2>
                        <h2 className="w-[17%] px-[10px] py-2 text-[16px] leading-8 text-[#121212]">%age</h2>
                        <h2 className="w-[17%] px-[10px] py-2 text-[16px] leading-8 text-[#121212]">Total Orders</h2>
                        <h2 className="w-[17%] px-[10px] py-2 text-[16px] leading-8 text-[#121212]">Total Sales</h2>
                    </div>
                    
                    {/* <CategoryInsightListItem /> */}
                </div>
            </div>
        </div>
    )
}

export default CategoryInsights;
